import {getCookie} from '../cookieHelper'

export function userConsentGranted() {
    const consentCookie = getCookie<UserConsentCookie>('userConsent', true) as UserConsentCookie
    console.log('consentCookie ==>', consentCookie)

    return !!consentCookie?.statistics
}
